import { ACTION } from '@cvent/react-analytics';

export const joinVirtualSession = {
  id: 'event_app_join_virtual_session',
  name: 'Join virtual session',
  type: ACTION,
  attributes: [
    'provider',
    'source',
    'sessionId',
    'viewType',
    'webcastType',
    'solutionType',
    'playerType',
    'simulatedLive',
    'sessionJoinedAs'
  ],
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  objectIdAttribute: 'sessionId',
  activityType: 'session.joined_virtual_room'
};

export const downloadSchedule = {
  id: 'event_app_download_schedule',
  name: 'Downloaded My Schedule',
  type: ACTION,
  destinations: ['Mixpanel']
};

export const openSessionDocument = {
  id: 'event_app_use_session_document_opened',
  name: 'Open Session Document',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  attributes: ['sessionId', 'sessionName', 'documentId', 'documentName', 'documentFormat', 'downloaded', 'factOrigin'],
  objectIdAttribute: 'sessionId',
  activityType: 'session.document_opened'
};

export const interactWithSession = {
  id: 'event_app_interact_session',
  name: 'Interact with Session',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  attributes: ['sessionId', 'sessionName', 'action', 'recommended', 'factOrigin'],
  objectIdAttribute: 'sessionId',
  activityType: 'session.interact'
};

export const certifiedSessionView = {
  id: 'event_app_certified_session_view',
  name: 'Certified Session View',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  attributes: ['sessionId', 'sessionName', 'factOrigin'],
  objectIdAttribute: 'sessionId',
  activityType: 'session.certified_view'
};

export const sessionSearch = {
  id: 'event_app_session_search',
  name: 'Session Search',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics'],
  attributes: ['searchTerm'],
  activityType: 'session.search'
};

export const sessionSearchAction = {
  id: 'event_app_session_search_action',
  name: 'Session Search Action',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics'],
  attributes: ['sessionId', 'sessionName', 'action', 'searchTerm'],
  objectIdAttribute: 'sessionId',
  activityType: 'session.search_interact'
};

export const sessionFilterAction = {
  id: 'event_app_session_filter_action',
  name: 'Session Filter Action',
  type: ACTION,
  destinations: ['Mixpanel'],
  attributes: ['filterType']
};

export const seamlessTransition = {
  id: 'seamless_transition',
  name: 'Seamless Transition',
  type: ACTION,
  attributes: ['type', 'action'],
  destinations: ['Mixpanel', 'Analytics']
};

export const enterPictureInPicture = {
  id: 'attendee_hub_enter_picture_in_picture',
  name: 'Enter Picture-In-Picture',
  type: ACTION,
  attributes: ['sessionId', 'sessionName', 'viewType', 'vendor'],
  destinations: ['Mixpanel', 'Analytics']
};

export const leavePictureInPicture = {
  id: 'attendee_hub_leave_picture_in_picture',
  name: 'Leave Picture-In-Picture',
  type: ACTION,
  attributes: ['sessionId', 'sessionName', 'viewType', 'vendor'],
  destinations: ['Mixpanel', 'Analytics']
};
